import React, { useCallback, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import app from "./firebase";
import { Form, Container, Button, Alert, Row, Col, Card } from "react-bootstrap";
import axios from 'axios';
import Loading from "../components/utilities/loading/loading";
import PasswordStrengthBar from 'react-password-strength-bar';
import './login.css';
import logo from '../media/Picture1.png';

const SignUp = ({ history }) => {
    const [url, setURL] = useState();
    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);

    useEffect(() => {
        axios.get('settings.json').then(res => setURL(res.data["confirmSignUp"]));
    }, []);

    const handleSignUp = useCallback(async event => {
        event.preventDefault();
        const { email, password } = event.target.elements;

        try {
            setLoading(true);
            await app.auth().createUserWithEmailAndPassword(email.value, password.value).then(async () => {
                await app.auth().currentUser.getIdToken(true).then(async function (idToken) {
                    axios.post(process.env.REACT_APP_confirmSignUp, {}, {
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': idToken
                        },
                    }).then((res) => {
                        if (res.request.status === 200) {
                            history.push("/");
                        }
                    });
                });
            }).catch((err) => {
                setError(err.message);
                setLoading(false);
            });
        } catch (error) {
            setError(error.message);
            setLoading(false);
        }
    }, [history]);

    const onPassChange = (event) => {
        setPassword(event.target.value);
    };

    if (loading) return <Loading />;

    return (
        <Container fluid className="login-page signup-page">
            <Row className="justify-content-center align-items-center min-vh-100">
                <Col md={10} lg={8} xl={7}>
                    <Card className="scientific-login-card border-primary">
                        <Row className="g-0">
                            <Col md={5} className="login-sidebar d-flex flex-column justify-content-between dark-blue-bg text-white">
                                <div className="p-4">
                                    <img src={logo} alt="Logo" className="scientific-logo mb-4" />
                                    <h3 className="sidebar-title">Parkinson Registry</h3>
                                    <div className="sidebar-divider bg-white"></div>
                                    <h5 className="sidebar-subtitle">Bioinformatics and Human Electrophysiology Laboratory</h5>
                                    <p className="sidebar-institution">Department of Informatics - Ionian University</p>
                                </div>
                                <div className="sidebar-footer p-4">
                                    <p className="text-center mb-0 text-white">&copy; {new Date().getFullYear()} BIHELab</p>
                                </div>
                            </Col>
                            <Col md={7}>
                                <Card.Body className="px-4 py-5">
                                    <h2 className="login-heading mb-4 text-primary">Create Account</h2>

                                    {error && (
                                        <Alert variant="danger" className="mb-4 scientific-alert">
                                            <Alert.Heading className="fs-6">Registration Error</Alert.Heading>
                                            <p className="small mb-0">{error}</p>
                                        </Alert>
                                    )}

                                    <Form onSubmit={handleSignUp}>
                                        <Form.Group className="mb-3" controlId="formEmail">
                                            <Form.Label className="form-label">Email Address</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                placeholder="Enter your email"
                                                className="scientific-input"
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="formPassword">
                                            <Form.Label className="form-label">Password (at least 6 characters)</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="password"
                                                placeholder="Enter your password"
                                                className="scientific-input"
                                                onChange={onPassChange}
                                                required
                                            />
                                            <PasswordStrengthBar password={password} />
                                        </Form.Group>
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            className="scientific-button w-100"
                                            disabled={password.length < 6}>
                                            Sign Up
                                        </Button>
                                    </Form>

                                    <div className="scientific-footer text-center mt-4">
                                        <p className="small text-muted mb-0">Secure Registration System</p>
                                    </div>
                                </Card.Body>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default withRouter(SignUp);
